module.exports = __webpack_public_path__ + "img/sparkle.7435b6a2.svg";